import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ONLINE_PSI_REGS_STATUSES, STATUS_COLORS } from 'shared/constants';
import './StudentDetailsModal.scss';
import { ModalInfo, Spinner } from 'shared/components';
import { useDispatch } from 'react-redux';
import * as onlineTestingActions from '../duck';

const PsiStudentDetailsModal = ({
  id,
  isOpen,
  handleClose,
  currentTestName
}) => {
  const { t } = useTranslation();
  const [examineeDetails, setExamineeDetails] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      (async () => {
        setLoadingData(true);
        const examinee = await dispatch(onlineTestingActions.getOnlineIndividualPsiReg(id, false));
        setExamineeDetails(examinee);
        if (examinee) {
          setLoadingData(false);
        }
      })();
    }
  }, [isOpen]);

  return <ModalInfo
            className="online-examinee-details-modal"
            modalIsOpen={isOpen}
            closeModal={handleClose}
            onSubmit={handleClose}
            headerTitle={t('onlineTesting.examineeDetails.details')}
            saveLabel={t('common.labels.close')}
          >
            {loadingData ? <Spinner hideText noHeight/> :
              <div>
                <h3
                  className="examinee-name">{`${examineeDetails.lastName}, ${examineeDetails.firstName}`}</h3>
                <div className="examinee-info-container">
                  <div>{t('onlineTesting.examineeDetails.matchID')}</div>
                  <div>{examineeDetails.matchId || "-"}</div>
                  <div>{t('onlineTesting.examineeDetails.testStatus')}</div>
                  <div className={STATUS_COLORS[examineeDetails.status]}>{ONLINE_PSI_REGS_STATUSES[examineeDetails.status] || "-"}</div>
                  {examineeDetails.markedCompleteReason && <>
                      <div>{t('onlineTesting.examineeDetails.reason')}</div>
                      <div>{examineeDetails.markedCompleteReason}</div>
                    </>
                  }
                  <div>{t('onlineTesting.examineeDetails.currentTest')}</div>
                  <div>{currentTestName}</div>
                  <div>{t('onlineTesting.examineeDetails.email')}</div>
                  <div>{examineeDetails.onlineUserName|| "-"}</div>
                  <div>{t('onlineTesting.examineeDetails.launchCode')}</div>
                  <div>{examineeDetails.onlinePassword|| "-"}</div>
                </div>
              </div>}
          </ModalInfo>;

};
export default PsiStudentDetailsModal;
